import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const getPatientNotes = async (patientID) => {
  if (!patientID) {
    return false;
  }
  const apiURL = API_HOST + '/admin/patient_notes/' + patientID;
  const { token, userID } = useCurrentUser();
  try {
    const { data } = await axios.get(apiURL, {
      headers: {
        Authorization: 'Bearer ' + token,
        'x-dqpn-user-id': userID,
      },
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
